import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa"; // Asegúrate de tener react-icons instalado
import { Helmet } from "react-helmet";

export const Questions = ({ data }) => {
  if (!data || !Array.isArray(data)) return null;

  return (
    <div id="exemption">
      <Helmet>
        <title>ABX Shipping - Preguntas frecuentes</title>
      </Helmet>
      <div className="container">
        <div className="row text-center">
          <div className="col-md-8 col-md-offset-2 section-title">
            <h2>PREGUNTAS FRECUENTES</h2>
          </div>
        </div>
        <div className="faq-list" style={{ maxWidth: "100%", margin: "0 auto", marginTop: "20px" }}>
          {data.map((item, index) => (
            <FaqItem key={index} title={item.titulo} description={item.descripcion} />
          ))}
        </div>
      </div>
    </div>
  );
};

const FaqItem = ({ title, description }) => {
  const [open, setOpen] = useState(false);

  const linkify = (text) => {
    const parts = [];
    const markdownRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
    let lastIndex = 0;
    let match;
  
    while ((match = markdownRegex.exec(text)) !== null) {
      const [fullMatch, linkText, url] = match;
      const start = match.index;
  
      // Texto antes del match
      if (start > lastIndex) {
        parts.push(text.substring(lastIndex, start));
      }
  
      // Enlace convertido
      parts.push(
        <a
          key={start}
          href={url}
         
          style={{ color: "blue" }}
        >
          {linkText}
        </a>
      );
  
      lastIndex = start + fullMatch.length;
    }
  
    // Texto después del último match
    if (lastIndex < text.length) {
      parts.push(text.substring(lastIndex));
    }
  
    return parts;
  };
  

  return (
    <div
      onClick={() => setOpen(!open)}
      style={{
        border: "1px solid #ccc",
        borderRadius: "5px",
        marginBottom: "10px",
        padding: "15px",
        cursor: "pointer",
        backgroundColor: "#f9f9f9",
        boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
        transition: "all 0.3s",
        position: "relative",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <strong>{title}</strong>
        <FaChevronDown
          style={{
            transition: "transform 0.3s",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            color: "#666",
          }}
        />
      </div>
      {open && (
        <div style={{ marginTop: "10px", textAlign: "left" }}>
          {description.split("\n").map((line, i) => {
            // Detectar si la línea comienza con una tabulación o espacios
            const isIndented = /^\s+[-•]/.test(line) || /^\t/.test(line);
            return (
              <p
                key={i}
                style={{
                  margin: 0,
                  paddingLeft: isIndented ? "20px" : 0,
                  whiteSpace: "pre-wrap",
                }}
              >
                {linkify(line)}
              </p>
            );
          })}
        </div>
      )}
    </div>
  );
};
